import React from "react";

const SlideData = () => {
  return (
    <>
      <h2 className="head">Other Activities</h2>
      <h4 className="activities"></h4>{" "}
    </>
  );
};

export default SlideData;
